import { render, staticRenderFns } from "./CreateSGPgConfigs.vue?vue&type=template&id=2744a12f&scoped=true"
import script from "./CreateSGPgConfigs.vue?vue&type=script&lang=js"
export * from "./CreateSGPgConfigs.vue?vue&type=script&lang=js"
import style0 from "./CreateSGPgConfigs.vue?vue&type=style&index=0&id=2744a12f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744a12f",
  null
  
)

export default component.exports